'use client';
import classnames from 'classnames';
import React, { useState } from 'react';
import { getIconBaseUrl } from '../../utils/assets';
import styles from './ChildAccordion.module.scss';
export const ChildAccordion = ({ className, title, openTitle, condensedIcon, margin = true, openByDefault = false, onChange = () => { }, id: incomingId, children, }) => {
    const [checked, setChecked] = useState(openByDefault);
    const titleId = title.replace(/ /g, '_');
    const id = incomingId !== null && incomingId !== void 0 ? incomingId : titleId;
    const onCheckedChange = () => {
        const newValue = !checked;
        setChecked(newValue);
        onChange({ checked: newValue, title });
    };
    return (<>
      <div className={classnames(styles.childAccordion, className)}>
        <div className={classnames(styles.childAccordion__tab, !margin && styles.childAccordion__noMargin)}>
          <input type='checkbox' id={id} onChange={onCheckedChange} checked={checked}/>
          <label className={classnames(styles.childAccordion__tabLabel, condensedIcon && styles.childAccordion__condensedIcon)} htmlFor={id}>
            {checked && openTitle ? openTitle : title}
            <img className={styles.childAccordion__icon} src={getIconBaseUrl('arrow-ios-right-blue.svg')} alt=''/>
          </label>
          <div className={styles.childAccordion__tabContent}>
            <div className={styles.childAccordion__tabContainer}>{children}</div>
          </div>
        </div>
      </div>
    </>);
};
